import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../config/firebase-config';

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return {
      success: 'yes',
      message: 'Se ha enviado un correo electrónico para restablecer tu contraseña. Si no lo encuentras en tu bandeja de entrada, revisa la carpeta de spam o correo no deseado.',
    };
  } catch (error) {
    let errorMessage = 'Error al enviar el correo de restablecimiento';
    if (error.code === 'auth/user-not-found') {
      errorMessage = 'No existe una cuenta con este correo electrónico';
    } else if (error.code === 'auth/invalid-email') {
      errorMessage = 'El correo electrónico no es válido';
    }
    return {
      success: 'no',
      error: errorMessage,
    };
  }
};
